module.exports = __webpack_public_path__ + "img/admin-confirm.d066d5fa.png";